<template>
  <div v-if="value">
    <a
      :href="value"
      @click.exact.prevent="$refs.lightbox.show(0)"
    >
      <img :src="value" class="thumb" alt=" ">
    </a>
    <Lightbox
      ref="lightbox"
      :images="[value]"
    />
  </div>
</template>

<script>
import Lightbox from '@/components/Lightbox.vue'

export default {
  name: 'DisplayImage',
  components: {
    Lightbox,
  },
  props: {
    value: String,
  },
}
</script>

<style lang="scss" scoped>
.thumb {
  max-width: 92px;
  max-height: 92px;
}
</style>
